import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import ManageVideo from "./ManageVideo";
import dayjs from "dayjs";
import NewVideoAdd from "../../dialogue/NewVideoAdd";
import { useDispatch, useSelector } from "react-redux";
import VideoComments from "./VideoComments";
import { getVideoStatsData } from "../../store/video/video.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconVideo,
  IconLockOpen,
  IconCurrencyDollar,
  IconUserCheck,
  IconUserQuestion,
  IconWorld,
  IconLock,
  IconLinkOff,
  IconBabyCarriage,
  IconMan,
  IconUsersGroup,
  IconMessage,
} from "@tabler/icons-react";

export default function VideoPage() {
  const dispatch = useDispatch();
  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("Manage Video");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { videoStatsData } = useSelector((state) => state.video);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getVideoStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Normal Videos",
      count: videoStatsData?.totalNormalVideos,
      Icon: IconVideo,
    },
    {
      title: "Total Free Videos",
      count: videoStatsData?.totalFreeVideos,
      Icon: IconLockOpen,
    },
    {
      title: "Total Paid Videos",
      count: videoStatsData?.totalPaidVideos,
      Icon: IconCurrencyDollar,
    },
    {
      title: "Total Real Videos",
      count: videoStatsData?.totalRealVideos,
      Icon: IconUserCheck,
    },
    {
      title: "Total Fake Videos",
      count: videoStatsData?.totalFakeVideos,
      Icon: IconUserQuestion,
    },
    {
      title: "Total Public Videos",
      count: videoStatsData?.totalPublicVideos,
      Icon: IconWorld,
    },
    {
      title: "Total Private Videos",
      count: videoStatsData?.totalPrivateVideos,
      Icon: IconLock,
    },
    {
      title: "Total Unlisted Videos",
      count: videoStatsData?.totalUnlistedVideos,
      Icon: IconLinkOff,
    },
    {
      title: "Total Kids Videos",
      count: videoStatsData?.totalKidsVideos,
      Icon: IconBabyCarriage,
    },
    {
      title: "Total Adults Videos",
      count: videoStatsData?.totalAdultsVideos,
      Icon: IconMan,
    },
    {
      title: "Total Both Videos",
      count: videoStatsData?.totalBothVideos,
      Icon: IconUsersGroup,
    },
    {
      title: "Total Video Comments",
      count: videoStatsData?.totalVideoComments,
      Icon: IconMessage,
    },
  ];

  return (
    <div className="userPage videoPage">
      <div
        style={{
          display: `${dialogueType === "editVideo" ? "none" : "block"}`,
        }}
      >
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={[
              "Manage Video",
              "Manage Video Comment",
              "Import Video",
            ]}
          />
        </div>
        <StatsCards cards={statsCards} />

        {multiButtonSelect == "Manage Video" && (
          <ManageVideo endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Manage Video Comment" && (
          <VideoComments endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Import Video" && (
          <NewVideoAdd setMultiButtonSelect={setMultiButtonSelect} />
        )}
      </div>
      {dialogueType === "editVideo" && <NewVideoAdd />}
    </div>
  );
}
